var HtmlComponent_default = {
  "htmlComponent": "lwqSD",
  "htmlComponent_placeholder": "WIWde"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
